var map = {
	"./1.svg": "EKB1",
	"./10.svg": "4S0H",
	"./2.svg": "nS5Z",
	"./3.svg": "BA8d",
	"./4.svg": "5Wm7",
	"./5.svg": "ui3n",
	"./6.svg": "nDdm",
	"./7.svg": "Y/7N",
	"./8.svg": "lAaB",
	"./9.svg": "yL4c",
	"./Star.svg": "f8E7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B4Oj";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.svg$
// module id = B4Oj
// module chunks = 1